const Jobs = () => import('./Jobs.vue')
const JobDetails = () => import('./JobDetails.vue')

export default [
  {
    name: 'admin-jobs',
    path: 'jobs',
    component: Jobs,
    meta: {
      access: ['org.settings.manage', 'org.settings.jobs.manage']
    }
  },
  {
    name: 'admin-job-details',
    path: 'jobs/:jobId',
    component: JobDetails,
    props: true,
    meta: {
      access: ['org.settings.manage', 'org.settings.jobs.manage']
    }
  }
]
